import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css';
import locale from 'element-plus/es/locale/lang/en';
import Vue3GoogleLogin from 'vue3-google-login';

import App from './App.vue';
import router from './router/index.js';
import store from './store/index.js';
import './helpers/index.js';
import 'normalize.css';
import './styles/index.scss';
import navigationGuard from './router/navigationGuard.js';
import './styles/icons/index.js';
import mitt from 'mitt';
import { googleLoginParams } from '@/helpers/google_oAuth.js';
//import VuePhotoAlbum from 'vue-photo-album'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { VueTelegramPlugin } from 'vue-tg'
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

// import 'vuefinder/dist/style.css'
// import VueFinder from 'vuefinder/dist/vuefinder'

// Initialize Vue App
const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store);
  
// Element Plus with Locale
app.use(ElementPlus, { locale });

// Google Sign-In Button
app.use(Vue3GoogleLogin, {
    clientId: googleLoginParams.client_id,
  });


// Telegram
app.use(VueTelegramPlugin);

// Vue Router
app.use(router);
router.beforeEach(navigationGuard);

// Vue Finder
// app.use(VueFinder);

//app.use(VuePhotoAlbum);
app.use(PrimeVue,
   {
    theme: {
      preset: Aura,
      options: {
          prefix: 'p',
          darkModeSelector: 'system',
          cssLayer: false
      }
  }
  }
);

app.component('QuillEditor', QuillEditor);

// Event Bus (mitt)
const emitter = mitt();
app.config.globalProperties.$emitter = emitter;

// Mount App
app.mount('#app');

export default app;
